/***********************************************************
Accordions
Used on Product Detail Page
***********************************************************/
function initAccordions(){
  document.querySelectorAll('.product-detail__accordion-title').forEach(button => {
    button.addEventListener('click', () => {
      const accordion = button.closest('.product-detail__accordion');
      const content = accordion.querySelector('.product-detail__accordion-content');
      const isOpen = button.classList.toggle('opened');

      if (isOpen) {
        const inner = content.querySelector('.product-detail__accordion-content-inner');
        content.style.height = inner.offsetHeight + 'px';
      } else {
        content.style.height = '0px';
      }

      accordion.classList.toggle('open');
      evaluateStickyProductDetail();
    });
  });
}